import { render } from "./WorkPhoneManage.vue?vue&type=template&id=2be9527a&scoped=true"
import script from "./WorkPhoneManage.vue?vue&type=script&lang=js"
export * from "./WorkPhoneManage.vue?vue&type=script&lang=js"

import "./WorkPhoneManage.vue?vue&type=style&index=0&id=2be9527a&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\四个火体育_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be9527a"]])

export default __exports__